export default
{
    ALWAYS: 'always',
    DATES: 'dates'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/opening-formats.js